import Table from './Table';

export * from './interface';

export default Table;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/view/view-table/index.tsx